import React from "react"
import Cabecalho from "../Cabecalho"
import { DashboardResumo } from "./components/DashboardResumo"

export function ResumoFornecedor({ modoInicial = false }: { modoInicial?: boolean }) {
    return (
        <>
            <Cabecalho pagina={modoInicial ? "Início" : "Desempenho"} />
            <DashboardResumo modoInicial={modoInicial} />
        </>
    )
}
